import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  activeSubMenuData: {
    title: '',
  },
};
export const sliceKey = 'activeSubMenu';

export const activeSubMenuSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    activeSubMenu: (state, { payload }) => {
      try {
        state.activeSubMenuData = payload.activeSubMenuData;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { activeSubMenu } = activeSubMenuSlice.actions;

export default activeSubMenuSlice.reducer;
